/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Project_Ids_Insurer_CompanyInputs */

const es_co2_error_project_ids_insurer_company = /** @type {(inputs: Error_Project_Ids_Insurer_CompanyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No puedes incluir proyectos de una empresa aseguradora.`)
};

/**

* @param {Error_Project_Ids_Insurer_CompanyInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_project_ids_insurer_company = /** @type {((inputs?: Error_Project_Ids_Insurer_CompanyInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Project_Ids_Insurer_CompanyInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_project_ids_insurer_company(inputs)
});